export default {"src":"/_next/static/media/skillz_logo_wordmark_dark.a03740ee.svg","height":1700,"width":6000,"blurWidth":0,"blurHeight":0};